var app = app || {};

app.init = function() {
    app.extend();
    app.tracyAjaxInit();

    let location = null;

    kenaz.ajax.on("start", function() {
        if (location !== null) {
            return;
        }
        location = window.location.href;
        NProgress.start();
    });

    kenaz.ajax.on("complete", function() {
        location = null;
        app.run();
        NProgress.done();
    });

    kenaz.ajax.on("success", function() {

    });

    kenaz.ajax.on("error", function() {
        generateFlashMessage("Omlouváme se, ale došlo k neočekávané chybě serveru.", "error");
    });

    FehuForms.pairSelector = "tr";
    app.run();
    kenaz.ajax.selector = "a.ajax, form.ajax";
    kenaz.ajax.init();
};

app.run = function() {
    FehuForms.findAndInit();
};

app.extend = function () {
    Kenaz.Ajax.prototype.runExtRedirect = function (response) {
        if (response.redirect) {
            window.location.href = response.redirect;
        }
    };
};

app.tracyAjaxInit = function() {
    let ajaxTracy = new AjaxTracy();
    window.at = ajaxTracy;
    let oldOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function() {
        this.addEventListener("load", function() {
            ajaxTracy.handleRequest(this);
        });
        oldOpen.apply(this, arguments);
    };
};
